import { Currencies } from "@orbital/games-frontend-library";
import React, { useContext, useEffect, useMemo, useState } from "react";
import floorFigure from "../../components/configs/floorFigure";
import {
  HistoryContainer,
  HistoryPageBox,
  HistoryPageBoxHeader,
  HistoryWrapper,
} from "./HistoryStyles";
import HistoryTabs from "./HistoryTabs";
import { AppContext } from "../../context/createContext";
import { useTranslation } from "../../locale/context";

const History = ({ history }: any) => {
  const [animation, setAnimation] = useState(false);
  const [currentData, setCurrentData] = useState(history.my);
  const [activeSubPage, setActiveSubPage] = useState<string>("my");
  const { config } = useContext(AppContext);
  const { prec } = config;

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      betId: t("common.liveBet.table.betId"),
      amount: t("common.liveBet.table.amount"),
      user: t("common.liveBet.table.user"),
      bet: t("common.liveBet.table.bet"),
      mult: t("common.liveBet.table.mult"),
      win: t("common.liveBet.table.win"),
    };
  }, [t]);

  const handleCurrentData = (data: any) => {
    setCurrentData(data);
  };
  useEffect(() => {
    setAnimation(true);
  }, []);

  useEffect(() => {
    setCurrentData(history[activeSubPage]);
  }, [history]);

  return (
    <HistoryContainer isActive={animation}>
      <HistoryTabs
        handleCurrentData={handleCurrentData}
        history={history}
        activeSubPage={activeSubPage}
        setActiveSubPage={setActiveSubPage}
      />
      <HistoryWrapper>
        {currentData.map((betInfo: any, id: any) => (
          <HistoryPageBox isWin={betInfo.winAmount > 0} key={id}>
            <HistoryPageBoxHeader isWin={betInfo.winAmount > 0}>
              <h1>{languagePack.betId}</h1>
              <p>#{betInfo.id}</p>
            </HistoryPageBoxHeader>
            <HistoryPageBoxHeader isWin={betInfo.winAmount > 0}>
              <h1>{languagePack.user}</h1>
              <p>{betInfo.user_name}</p>
            </HistoryPageBoxHeader>
            <HistoryPageBoxHeader isWin={betInfo.winAmount > 0}>
              <h1>{languagePack.mult}</h1>
              <p>{floorFigure(betInfo.winCoef.toString(), prec)}x</p>
            </HistoryPageBoxHeader>
            <HistoryPageBoxHeader isWin={betInfo.winAmount > 0}>
              <h1>{languagePack.amount}</h1>
              <p>
                {betInfo.currency !== undefined
                  ? Currencies[betInfo.currency]
                  : ""}
                {floorFigure(betInfo.betAmount.toString(), prec)}
              </p>
            </HistoryPageBoxHeader>
            <HistoryPageBoxHeader isWin={betInfo.winAmount > 0}>
              <h1>{languagePack.win}</h1>
              <p>
                {betInfo.winAmount > 0
                  ? `+${
                      betInfo.currency !== undefined
                        ? Currencies[betInfo.currency]
                        : ""
                    }`
                  : ""}
                {floorFigure(betInfo.winAmount.toString(), prec)}
              </p>
            </HistoryPageBoxHeader>
          </HistoryPageBox>
        ))}
      </HistoryWrapper>
    </HistoryContainer>
  );
};

export default History;
